






















































































































































































































































































































































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Mixins, Component, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';

import exceljs from 'exceljs';
import AxAPI from '@/api';
import moment from 'moment';

type Group = I.AxZone;

type PageInfo = I.EventSearchPageInfo;

type AccessList = I.EventAccessData & { num?: number };
type DoorList = I.EventDoorList & { num?: number };
type SensorList = I.EventSensorList & { num?: number };
type SystemList = I.EventSystemList & { num?: number };
type DataItem = U.DataItem<AccessList | DoorList | SensorList | SystemList, State>;

type AccessDataStore = U.DataStore<AccessList>;
type DoorDataStore = U.DataStore<DoorList>;
type SensorDataStore = U.DataStore<SensorList>;
type SystemDataStore = U.DataStore<SystemList>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

class State {
  listCompanyCode: I.CodeData[];
  listDeptCodeA: I.CodeData[];
  listDeptCodeB: I.CodeData[];
  listDutyCodeA: I.CodeData[];
  listUserType: I.CodeData[];
  listEventCode: I.CodeData[];
  listUserStatus: I.CodeData[];

  // listDoor: I.DoorData[];
  listDoor: I.CodeData[];

  // listACU: I.AcuDetail[];
  listACU: I.CodeData[];

  // listSensor: I.DeviceData[];
  listSensor: I.CodeData[];

  empno: string;
  userName: string;
  cardNo: string;

  constructor() {
    this.listACU = [];
    this.listSensor = [];
    this.listCompanyCode = [];
    this.listDeptCodeA = [];
    this.listDeptCodeB = [];
    this.listDutyCodeA = [];
    this.listUserType = [];
    this.listDoor = [];
    this.listEventCode = [];
    this.listUserStatus = [];

    this.empno = '' as never;
    this.userName = '' as never;
    this.cardNo = '' as never;
  }

  get cleared() {
    return (
      [
        this.listACU,
        this.listSensor,
        this.listCompanyCode,
        this.listDeptCodeA,
        this.listDeptCodeB,
        this.listDutyCodeA,
        this.listUserType,
        this.listDoor,
        this.listUserStatus
      ]
        .map(x => x.length > 0)
        .filter(x => x === true).length === 0 &&
      this.empno.length === 0 &&
      this.userName.length === 0 &&
      this.cardNo.length === 0
    );
  }
}

class DialogState {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: unknown[];
  headers: unknown[];
  items: unknown[];
  callback: () => Promise<void>;

  constructor() {
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.callback = async () => {};
  }
}

enum TabKind {
  Access,
  Door,
  Sensor,
  System
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
  dialogState!: DialogState;
  currentTab!: TabKind;
  zoneCode!: number;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await this.API.call.event.get();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async searchAccessEvent(packet: I.PacketEventSearch) {
    const result = await this.API.call.event.search(packet);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async searchDoorEvent(packet: I.PacketDoorEventSearch) {
    const result = await this.API.call.event.doorSearch(packet);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async searchSensorEvent(packet: I.PacketSensorEventSearch) {
    const result = await this.API.call.event.sensorSearch(packet);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async searchSystemEvent(packet: I.PacketSystemEventSearch) {
    const result = await this.API.call.event.systemSearch(packet);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '출입문',
      store: new DataStore<DoorList>({
        headers: {
          num: { text: '순번', sortable: false },
          zoneName: '구역',
          doorName: '출입문',
          eventTime: '시간',
          eventName: '이벤트 정보'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '센서',
      store: new DataStore<SensorList>({
        headers: {
          num: { text: '순번', sortable: false },
          zoneName: '구역',
          sensorName: '센서',
          eventTime: '시간',
          eventName: '이벤트 정보'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[this.currentTab];
  }
}

@Component
class SelectDialogHandler extends BaseClass {
  ignoreWatch = 0;

  @Watch('zoneCode')
  async onZoneCodeChanged(newVal: number, oldVal: number) {
    if (this.ignoreWatch > Date.now()) {
      return;
    }

    if (this.dataItem.state.listACU.length && newVal !== oldVal) {
      const result = await this.showConfirmModal(
        '확인',
        '구역을 변경하면 ACU 필터가<br />초기화됩니다. 계속하시겠습니까?<br /><br />※ 초기화하지 않으면 구역을 변경<br />할 수 없습니다.',
        ['네', '아니오']
      );
      if (result === 0) {
        this.dataItem.state.listACU = [];
      } else {
        this.ignoreWatch = Date.now() + 500;
        this.zoneCode = oldVal;
      }
    } else if (this.dataItem.state.listDoor.length && newVal !== oldVal) {
      const result = await this.showConfirmModal(
        '확인',
        '구역을 변경하면 출입문 검색 필터가<br />초기화됩니다. 계속하시겠습니까?<br /><br />※ 초기화하지 않으면 구역을 변경<br />할 수 없습니다.',
        ['네', '아니오']
      );
      if (result === 0) {
        this.dataItem.state.listDoor = [];
      } else {
        this.ignoreWatch = Date.now() + 500;
        this.zoneCode = oldVal;
      }
    }
  }

  getTargetKindEvents() {
    const entireEvents = this.pageInfo.listEventCode;

    switch (this.currentTab) {
      case TabKind.Access: {
        const begin = '인증 성공 : 정상 출입 (입구)';
        const end = '인증 제한 : 설정되지 않은 ID 형식 수신(Wiegand bit 에러)';

        return entireEvents.slice(
          entireEvents.findIndex(x => x.name === begin),
          entireEvents.findIndex(x => x.name === end) + 1
        );
      }
      case TabKind.Door: {
        const begin = '출입문 센서 단선';
        const end = '시스템 제어 : 출입문 상태 초기화(화재)';

        return entireEvents.slice(
          entireEvents.findIndex(x => x.name === begin),
          entireEvents.findIndex(x => x.name === end) + 1
        );
      }
      case TabKind.Sensor: {
        const begin = 'Sensor 감지';
        const end = 'Sensor 감지 해제 (By operator)';

        return entireEvents.slice(
          entireEvents.findIndex(x => x.name === begin),
          entireEvents.findIndex(x => x.name === end) + 1
        );
      }
      case TabKind.System: {
        const begin = 'F/W 시작';
        const end = '정전 복구';

        return entireEvents.slice(
          entireEvents.findIndex(x => x.name === begin),
          entireEvents.findIndex(x => x.name === end) + 1
        );
      }
    }
  }

  openEventSelectDialog() {
    const title = '이벤트 선택';
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    const items = this.getTargetKindEvents();

    const selected = this.dataItem.state.listEventCode;

    const callback = async () => {
      const selected = this.dialogState.selected as I.CodeData[];
      this.dataItem.state.listEventCode = selected.sort((a, b) => a.code.localeCompare(b.code));
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openACUSelectDialog() {
    const title = 'ACU 선택';
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    const items: I.CodeData[] = [];
    this.pageInfo.listACU
      .filter(x => x.zoneCode === this.zoneCode)
      .forEach(x => {
        items.push({
          code: x.acuID.toString(),
          name: x.name
        });
      });
    const selected = this.dataItem.state.listACU;

    const callback = async () => {
      const selected = this.dialogState.selected as I.CodeData[];
      this.dataItem.state.listACU = selected.sort((a, b) => a.code.localeCompare(b.code));
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openCodeSelectDialog(title: string, name: string) {
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    const items = ((this.pageInfo as unknown) as { [name: string]: I.CodeData[] })[name];
    const selected = ((this.dataItem.state as unknown) as {
      [name: string]: I.CodeData[];
    })[name];

    const callback = async () => {
      const selected = this.dialogState.selected as I.CodeData[];
      ((this.dataItem.state as unknown) as { [name: string]: I.CodeData[] })[
        name
      ] = selected.sort((a, b) => a.code.localeCompare(b.code));
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  // TODO: 삭제된 출입문에 대한 처리가 필요
  openDoorSelectDialog() {
    const title = '출입문 선택';
    const headers = [{ text: '이름', value: 'name', align: 'start' }];

    // 현재 선택된 구역 코드만 나오도록 함
    const items = this.pageInfo.listDoor.filter(x => x.zoneCode === this.zoneCode);
    const selected = this.dataItem.state.listDoor;

    const callback = async () => {
      const selected = this.dialogState.selected as I.DoorData[];
      this.dataItem.state.listDoor = selected
        .sort((a, b) => (a.code > b.code ? 1 : -1))
        .map(x => {
          const codeData: I.CodeData = {
            code: x.code.toString(),
            name: x.name
          };
          return codeData;
        });
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openSelectDialog(
    title: string,
    headers: unknown[],
    items: unknown[],
    selected: unknown[],
    callback: () => Promise<void>
  ) {
    this.dialogState.show = true;
    this.dialogState.title = title;
    this.dialogState.headers = headers as never;
    this.dialogState.items = items as never;
    this.dialogState.selected = selected as never;
    this.dialogState.callback = callback;
  }

  async closeDialog() {
    this.dialogState.show = false;
    await this.dialogState.callback();

    // 애니메이션 트랜지션이 끝나고나서 Dialog가 초기화되어야 하므로
    setTimeout(() => {
      this.dialogState = new DialogState();
    }, 100);
  }

  onDialogChanged() {
    this.dialogState.callback();
  }

  onDialogRowClicked(item: never) {
    const idx = this.dialogState.selected.findIndex(x => x === item);
    if (idx > -1) {
      this.dialogState.selected.splice(idx, 1);
    } else {
      this.dialogState.selected.push(item);
    }
  }
}

@Component
class ExcelExportHandler extends Mixins(AxPage) {
  dataItem!: DataItem;

  async onExportExcelConfirm(prefix: string) {
    if (!this.dataItem.description.length) {
      await this.showErrorModal('오류', '조회 후 엑셀 다운로드가 가능합니다');
      return;
    }

    const result = await this.showConfirmModal(
      '확인',
      '검색한 데이터들을 엑셀로 내보냅니다<br />계속하시겠습니까?',
      ['네', '아니오']
    );
    if (result === 0) {
      this.setLoading(true);
      setTimeout(() => this.onExportExcel(prefix), 500);
    }
  }

  async onExportExcel(prefix: string) {
    try {
      const colNames = (n: number) => {
        const ordA = 'A'.charCodeAt(0);
        const ordZ = 'Z'.charCodeAt(0);
        const len = ordZ - ordA + 1;

        let s = '';
        while (n >= 0) {
          s = String.fromCharCode((n % len) + ordA) + s;
          n = Math.floor(n / len) - 1;
        }
        return s;
      };

      moment.locale('ko');
      const momentTime = moment(Date.now());
      const outputPrefix = `${prefix.replace(/\s/g, '_')}_${this.dataItem.name.replace(
        /\s/g,
        ''
      )}_`;

      const workbook = new exceljs.Workbook();
      const worksheet = workbook.addWorksheet('sheet', { properties: { defaultColWidth: 10 } });
      const headers = this.dataItem.store.getHeaders();

      // 엑셀 내보내기시 수작업으로 순번 필드를 만드므로 순번 필드를 삭제시킨다
      const headerEntries = Object.entries(headers).filter(x => x[0] !== 'num');
      const headerKeys = headerEntries.map(x => x[0]);
      const headerValues = headerEntries.map(x => x[1]);

      if (!headers) {
        await this.showErrorModal('확인', '올바르지 않은 테이블 구조입니다');
        return;
      }

      // 헤더 작성 (식수 조회 [사원별] 등등..)
      const headerSize = headerKeys.length;
      worksheet.mergeCells(`A1:${colNames(headerSize)}1`);
      worksheet.getCell('A1').value = `${prefix} [${this.dataItem.name}]`;
      worksheet.getCell('A1').font = { family: 4, size: 18, bold: true };
      worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('A1').border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      let row = 2;

      // 구역이나 회사 등등은 검색시 만들어둔 description table을 참고한다
      // 검색 당시와 현재 조건이 다를 수 있으므로 이를 보완한 방법
      this.dataItem.description.forEach(x => {
        worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
        worksheet.getCell(`A${row++}`).value = x;
      });

      // 생성 시간은 검색 시간과 무관하게 현재 시간을 기준으로 삼는다

      worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
      worksheet.getCell(`A${row++}`).value = `생성시간 : ${momentTime.format('YYYY-MM-DD LT')}`;

      worksheet.insertRow(
        row,
        [
          'No.',
          ...headerValues.map(x => {
            if (typeof x === 'string') return x;
            else {
              const y = (x as unknown) as { [key: string]: unknown };
              if (y.text) {
                return y.text;
              } else {
                return y;
              }
            }
          })
        ],
        'i'
      );
      const headerRow = row++;
      // 테두리 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.style = {};
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      // 아이템 필터. Header에 들어간 item만 뽑는다
      this.dataItem.store.getItems().forEach((x, idx) => {
        const arr: unknown[] = [idx + 1];
        headerKeys.forEach(y => {
          if (y === 'eventTime') {
            arr.push(this.formatTime(((x as unknown) as { [key: string]: string })[y]));
          } else {
            arr.push(((x as unknown) as { [key: string]: unknown })[y]);
          }
        });
        worksheet.insertRow(row++, arr, 'i');
      });

      // 헤더 라인에 음영 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFBFBFBF' },
          bgColor: { argb: 'FFFFFF00' }
        };

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      // 엑셀 파일을 저장한다
      const xls64 = await workbook.xlsx.writeBuffer();
      const a = document.createElement('a');
      const data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = URL.createObjectURL(data);
      a.href = url;
      a.download = outputPrefix + momentTime.format('YYYY_MM_DD_HH_mm_ss') + '.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    } catch (e) {
      await this.showErrorModal('엑셀 내보내기 오류', e.message);
    }
    this.setLoading(false);
  }
}

@Component
export class DateHandler extends Vue {
  //beginDate = new Date('2016-01-01').toISOString().substr(0, 10);
  beginDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  beginDateMenu = false;
  endDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  endDateMenu = false;

  beginTime = '00:00';
  beginTimeMenu = false;
  endTime = '23:59';
  endTimeMenu = false;

  filterBeginTime = '00:00';
  filterBeginTimeMenu = false;

  filterEndTime = '23:59';
  filterEndTimeMenu = false;
}

@Component
export class AdvSearchHandler extends Mixins(AxPage) {
  isOpenAdvSearch!: boolean;
  dataItem!: DataItem;

  onToggleAdvSearch() {
    this.isOpenAdvSearch = !this.isOpenAdvSearch;
  }

  async confirmClearAdvSearch(text: string) {
    const result = await this.showConfirmModal('확인', text, ['네', '아니오']);
    if (result === 0) {
      this.dataItem.state = new State();
    }
  }

  async onClearAdvSearch() {
    const result = await this.showConfirmModal('확인', '고급 검색 필터를 초기화할까요?', [
      '네',
      '아니오'
    ]);
    if (result === 0) {
      this.dataItem.state = new State();
    }
  }

  async onClearSearch() {
    this.dataItem.search = '';
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  currentTab = TabKind.Access;
  dialogState = new DialogState();

  pageInfo = {} as PageInfo;
  zoneCode = 0;
  listZone: I.AxZone[] = [];
  isOpenAdvSearch = false;
  revertZone = false;
  dates = [];
}

// vue-class-component의 mixins는 생성자가 5개 이상 넘어가면 unknown으로 캐스팅됨
// 이를 방지하기 위해서 여러 클래스를 분할하는 Mixin 패턴을 사용하려면
// 클래스를 5개씩 끊어서 넣어줘야 한다
const Handlers = Mixins(
  Mixins(ApiHandler, DataItemHandler, DateHandler, ExcelExportHandler),
  Mixins(AdvSearchHandler, SelectDialogHandler)
);

@Component
export default class EventSearch extends Mixins(BaseData, Handlers) {
  async prepare() {
    const pageInfo = await this.getPageInfo();
    if (pageInfo) {
      this.pageInfo = pageInfo;
      this.listZone = this.getZoneList();
      this.zoneCode = this.getZoneList()[0]?.code || 0;
    }
  }

  makeAccessPacket(): I.PacketEventSearch {
    return {
      account: '',
      zoneCode: this.zoneCode,
      searchWord: this.dataItem.search,
      pageNum: 0,
      listCompanyCode: this.dataItem.state.listCompanyCode,
      listDeptCodeA: this.dataItem.state.listDeptCodeA,
      listDeptCodeB: this.dataItem.state.listDeptCodeB,
      listDutyCodeA: this.dataItem.state.listDutyCodeA,
      listDoor: this.dataItem.state.listDoor,
      listUserType: this.dataItem.state.listUserType,
      listEventCode: this.dataItem.state.listEventCode,
      listUserStatus: this.dataItem.state.listUserStatus,
      dateFrom: `${this.beginDate}T${this.beginTime}:00.000Z`,
      dateTo: `${this.endDate}T${this.endTime}:00.000Z`,
      searchTimeFrom: `${this.filterBeginTime.replace(/:/g, '')}`,
      searchTimeTo: `${this.filterEndTime.replace(/:/g, '')}`,
      hourFrom: /^(\d{2}):(\d{2})$/.exec(this.beginTime)?.[1] || '00',
      minuteFrom: /^(\d{2}):(\d{2})$/.exec(this.beginTime)?.[2] || '00',
      hourTo: /^(\d{2}):(\d{2})$/.exec(this.endTime)?.[1] || '23',
      minuteTo: /^(\d{2}):(\d{2})$/.exec(this.endTime)?.[2] || '59',
      userName: this.dataItem.state.userName,
      empno: this.dataItem.state.empno,
      cardNo: this.dataItem.state.cardNo
    };
  }

  makeDoorPacket(): I.PacketDoorEventSearch {
    return {
      account: '',
      zoneCode: this.zoneCode,
      listDoor: this.dataItem.state.listDoor,
      listEventCode: this.dataItem.state.listEventCode,
      dateFrom: `${this.beginDate}T${this.beginTime}:00.000Z`,
      dateTo: `${this.endDate}T${this.endTime}:00.000Z`,
      searchTimeFrom: `${this.filterBeginTime.replace(/:/g, '')}`,
      searchTimeTo: `${this.filterEndTime.replace(/:/g, '')}`,
      hourFrom: /^(\d{2}):(\d{2})$/.exec(this.beginTime)?.[1] || '00',
      minuteFrom: /^(\d{2}):(\d{2})$/.exec(this.beginTime)?.[2] || '00',
      hourTo: /^(\d{2}):(\d{2})$/.exec(this.endTime)?.[1] || '23',
      minuteTo: /^(\d{2}):(\d{2})$/.exec(this.endTime)?.[2] || '59'
    };
  }

  makeSensorPacket(): I.PacketSensorEventSearch {
    return {
      account: '',
      zoneCode: this.zoneCode,
      listSensor: this.dataItem.state.listSensor,
      listEventCode: this.dataItem.state.listEventCode,
      dateFrom: `${this.beginDate}T${this.beginTime}:00.000Z`,
      dateTo: `${this.endDate}T${this.endTime}:00.000Z`,
      searchTimeFrom: `${this.filterBeginTime.replace(/:/g, '')}`,
      searchTimeTo: `${this.filterEndTime.replace(/:/g, '')}`,
      hourFrom: /^(\d{2}):(\d{2})$/.exec(this.beginTime)?.[1] || '00',
      minuteFrom: /^(\d{2}):(\d{2})$/.exec(this.beginTime)?.[2] || '00',
      hourTo: /^(\d{2}):(\d{2})$/.exec(this.endTime)?.[1] || '23',
      minuteTo: /^(\d{2}):(\d{2})$/.exec(this.endTime)?.[2] || '59'
    };
  }

  makeSystemPacket(): I.PacketSystemEventSearch {
    return {
      account: '',
      zoneCode: this.zoneCode,
      listAccu: this.dataItem.state.listACU,
      listEventCode: this.dataItem.state.listEventCode,
      dateFrom: `${this.beginDate}T${this.beginTime}:00.000Z`,
      dateTo: `${this.endDate}T${this.endTime}:00.000Z`,
      searchTimeFrom: `${this.filterBeginTime.replace(/:/g, '')}`,
      searchTimeTo: `${this.filterEndTime.replace(/:/g, '')}`,
      hourFrom: /^(\d{2}):(\d{2})$/.exec(this.beginTime)?.[1] || '00',
      minuteFrom: /^(\d{2}):(\d{2})$/.exec(this.beginTime)?.[2] || '00',
      hourTo: /^(\d{2}):(\d{2})$/.exec(this.endTime)?.[1] || '23',
      minuteTo: /^(\d{2}):(\d{2})$/.exec(this.endTime)?.[2] || '59'
    };
  }

  onSearchEvent() {
    switch (this.currentTab) {
      case TabKind.Access:
        return this.onAccessSearchEvent();
      case TabKind.Door:
        return this.onDoorSearchEvent();
      case TabKind.Sensor:
        return this.onSensorSearchEvent();
      case TabKind.System:
        return this.onSystemSearchEvent();
    }
  }

  async onAccessSearchEvent() {
    this.setLoading(true);
    let zoneName;
    const result = await this.searchAccessEvent(this.makeAccessPacket());
    this.setLoading(false);
    if (result) {
      this.dataItem.store.setItems(result.listEvent);
      this.dataItem.description = [];
      this.dataItem.description.push(
        `조회기간 : ${this.beginDate} ${this.beginTime} ~ ${this.endDate} ${this.endTime}`
      );

      if (this.zoneCode === -1) {
        zoneName = '전체';
      } else {
        zoneName = this.listZone.find(x => x.code === this.zoneCode)?.name;
      }
      this.dataItem.description.push(`구역 : ${zoneName || '(Code ' + this.zoneCode + ')'}`);

      // 엑셀 출력시 description 테이블을 참조해 세부 내용들을 생성한다
      const {
        listCompanyCode,
        listDeptCodeA,
        listDeptCodeB,
        listDutyCodeA,
        listDoor,
        listUserType
      } = this.dataItem.state;

      if (this.dataItem.search.length > 0) {
        this.dataItem.description.push(`키워드 : ${this.dataItem.search}`);
      }

      if (this.dataItem.state.empno.length > 0) {
        this.dataItem.description.push(`사원번호 : ${this.dataItem.state.empno}`);
      }

      if (this.dataItem.state.userName.length > 0) {
        this.dataItem.description.push(`이름 : ${this.dataItem.state.userName}`);
      }

      if (this.dataItem.state.cardNo.length > 0) {
        this.dataItem.description.push(`카드번호 : ${this.dataItem.state.cardNo}`);
      }

      if (listCompanyCode.length) {
        this.dataItem.description.push(`회사 : ${listCompanyCode.map(x => x.name).join(', ')}`);
      }

      if (listDeptCodeA.length) {
        this.dataItem.description.push(`사업장 : ${listDeptCodeA.map(x => x.name).join(', ')}`);
      }

      if (listDeptCodeB.length) {
        this.dataItem.description.push(`부서 : ${listDeptCodeB.map(x => x.name).join(', ')}`);
      }

      if (listDutyCodeA.length) {
        this.dataItem.description.push(`직급 : ${listDutyCodeA.map(x => x.name).join(', ')}`);
      }

      if (listDoor.length) {
        this.dataItem.description.push(`리더기 : ${listDoor.join(', ')}`);
      }

      if (listUserType.length) {
        this.dataItem.description.push(`사용자 유형 : ${listUserType.join(', ')}`);
      }
    }
  }

  async onDoorSearchEvent() {
    this.setLoading(true);
    const result = await this.searchDoorEvent(this.makeDoorPacket());
    let zoneName;
    this.setLoading(false);
    if (result) {
      this.dataItem.store.setItems(result);
      this.dataItem.description = [];
      this.dataItem.description.push(
        `조회기간 : ${this.beginDate} ${this.beginTime} ~ ${this.endDate} ${this.endTime}`
      );
      if (this.zoneCode === -1) {
        zoneName = '전체';
      } else {
        zoneName = this.listZone.find(x => x.code === this.zoneCode)?.name;
      }
      this.dataItem.description.push(`구역 : ${zoneName || '(Code ' + this.zoneCode + ')'}`);

      // 엑셀 출력시 description 테이블을 참조해 세부 내용들을 생성한다
      const { listDoor, listEventCode } = this.dataItem.state;

      if (listDoor.length) {
        this.dataItem.description.push(`리더기 : ${listDoor.join(', ')}`);
      }

      if (listEventCode.length) {
        this.dataItem.description.push(`이벤트 : ${listEventCode.join(', ')}`);
      }
    }
  }

  async onSensorSearchEvent() {
    this.setLoading(true);
    let zoneName;
    const result = await this.searchSensorEvent(this.makeSensorPacket());
    this.setLoading(false);
    if (result) {
      this.dataItem.store.setItems(result);
      this.dataItem.description = [];
      this.dataItem.description.push(
        `조회기간 : ${this.beginDate} ${this.beginTime} ~ ${this.endDate} ${this.endTime}`
      );

      if (this.zoneCode === -1) {
        zoneName = '전체';
      } else {
        zoneName = this.listZone.find(x => x.code === this.zoneCode)?.name;
      }
      this.dataItem.description.push(`구역 : ${zoneName || '(Code ' + this.zoneCode + ')'}`);

      // 엑셀 출력시 description 테이블을 참조해 세부 내용들을 생성한다
      const { listSensor, listEventCode } = this.dataItem.state;

      if (listSensor.length) {
        this.dataItem.description.push(`센서 : ${listSensor.join(', ')}`);
      }

      if (listEventCode.length) {
        this.dataItem.description.push(`이벤트 : ${listEventCode.join(', ')}`);
      }
    }
  }

  async onSystemSearchEvent() {
    this.setLoading(true);
    const result = await this.searchSystemEvent(this.makeSystemPacket());
    this.setLoading(false);
    if (result) {
      this.dataItem.store.setItems(result);
      this.dataItem.description = [];
      this.dataItem.description.push(
        `조회기간 : ${this.beginDate} ${this.beginTime} ~ ${this.endDate} ${this.endTime}`
      );

      this.dataItem.description.push(
        `구역 : ${this.getZoneList().find(x => x.code === this.zoneCode)?.name ||
          '(Code ' + this.zoneCode + ')'}`
      );

      // 엑셀 출력시 description 테이블을 참조해 세부 내용들을 생성한다
      const { listACU, listEventCode } = this.dataItem.state;

      if (listACU.length) {
        this.dataItem.description.push(`ACU : ${listACU.join(', ')}`);
      }

      if (listEventCode.length) {
        this.dataItem.description.push(`이벤트 : ${listEventCode.join(', ')}`);
      }
    }
  }
}
